import { Checkbox, Field, RadioGroup, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, PageSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { ConditionOfSampleTested } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { TestProcedure } from '../../types';

let SpecimenPreparationPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const isMaterialWashed = useSelector(
    pipe(createWorksheetSelector!('Preparation.MaterialWashed'), valueOrDefault(false))
  );
  const testProcedure = useSelector(createWorksheetSelector!('Preparation.Method'));

  const GetSampleTestedConditionOptions = () => {
    switch (testProcedure) {
      case TestProcedure.Standard:
        return [
          { label: 'Pre-dried', value: ConditionOfSampleTested.PreDried },
          { label: 'Oven dry', value: ConditionOfSampleTested.OvenDry },
        ];
      case TestProcedure.AnnexA:
        return [
          { label: 'As received', value: ConditionOfSampleTested.AsReceived },
          { label: 'Air Dried', value: ConditionOfSampleTested.AirDried },
        ];
    }
  };

  return (
    <PageSection heading="Specimen Preparation">
      <ListFieldSection>
        {testProcedure === TestProcedure.AnnexB ? (
          <Field
            input={<TextOutput />}
            name="WholePortion.Preparation.ConditionOfSampleTested"
            value="Washed wet then oven-dried"
          />
        ) : (
          <Field
            input={<RadioGroup />}
            name="WholePortion.Preparation.ConditionOfSampleTested"
            options={GetSampleTestedConditionOptions()}
            confirmText="Changing the condition of received sample may clear data. Are you sure you want to continue?"
          />
        )}

        {/* The checkbox for indicating washing will occur is an exception
            in this section in that is not mapped to the whole portion but the "test preparation" data
            as it indicates that washing will occur at some point during the whole test.
            (The washed portion will be the whole portion when no initial separation occurs,
               otherwise the first separation fine portion subspecimen)
          */}
        <Field
          input={<Checkbox />}
          name="Preparation.MaterialWashed"
          confirmText="This action will clear any entered washing data. Are you sure you want to continue?"
          confirm={isMaterialWashed}
          disabled={testProcedure !== TestProcedure.Standard}
        />
      </ListFieldSection>
    </PageSection>
  );
};

SpecimenPreparationPageSection = withInjectedProps(SpecimenPreparationPageSection);

export { SpecimenPreparationPageSection };
export default SpecimenPreparationPageSection;
